import React from "react"
import btn_facebook from "../../images/bottom_images/btn_facebook.png"
import btn_instagram from "../../images/bottom_images/btn_instagram.png"
import btn_twitter from "../../images/bottom_images/btn_twitter.png"
import Here4TN_archive from "../../images/bottom_images/Here4TN_archive.png"
import Optum_Here4TN from "../../images/bottom_images/Optum_Here4TN.png"

export default (props)=>{


    return (<div style={{marginTop:10,backgroundColor:"#434448"}} className="container-fluid">
            <div className="container">
    <div style={{padding:10}} className="row">
            <div className="mt-md-2 col-md-6 text-md-left text-center col-sm-12">
                    <img style={{width:350}} src={Optum_Here4TN}/>
                    
            </div>    
            <div className=" mt-4 mt-md-5 col-md-6 col-sm-12 text-center text-md-right pr-4">
                     <div  >
                     <div   className="mt-4 mt-sm-0 socialLogos">
                <a
                
               title="facebook page"
                target="_blank"
                href="https://www.facebook.com/ParTNersForHealthTN/">
                     <img className="btn-icon" src={btn_facebook} />
                     </a>
                    <a
                    target="_blank"
                    title="twitter page"
                    href="https://twitter.com/ParTNerHealthTN">
                     <img  className="btn-icon" src={btn_twitter} />
                     </a>
                     <a 
                     target="_blank"
                     title="instagram page" href="https://www.instagram.com/partnersforhealth/">
                     <img  className="btn-icon" src={btn_instagram} />
                     </a>
                     
                     </div>
                     <div className="mt-3">
                   
                         </div>                            
                              
                    </div>       
            </div>
    </div></div></div>);
}